import React from 'react';
import './FabYouth.css';

function FabYouth() {
  return (
    <div className="fab_youth_container">
      <h1 className="youth_main_title">3 ON 3</h1>

      <section className="youth_section">
        <h3>WHAT IS 3 ON 3 BASKETBALL?</h3>
        <p>
          3-on-3 basketball is a fast-paced and exciting variation of traditional basketball
          where teams of three players compete against one another. Each game typically takes
          place on half of a basketball court, allowing for quicker play and more scoring
          opportunities for each player.
        </p>
      </section>

      <hr className="divider" />

      <section className="youth_section">
        <h3>WHY 3 ON 3?</h3>
        <ul>
          <li>
            <strong>Enhanced Skill Development:</strong>
            <ul>
              <li><strong>More Touches on the Ball:</strong> With fewer players on the court, each player has more opportunities to handle the ball, improving their dribbling, passing, and shooting skills.</li>
              <li><strong>Versatility:</strong> Players are encouraged to develop a well-rounded skill set since they will play both offensive and defensive roles, allowing them to learn various aspects of the game.</li>
            </ul>
          </li>
          <li>
            <strong>Increased Participation:</strong>
            <ul>
              <li><strong>Smaller Teams:</strong>  The smaller team size allows for more involvement, ensuring that all players are engaged in the game rather than being sidelined.</li>
              <li><strong>Friendlier Atmosphere:</strong> 3-on-3 promotes a more intimate setting where players can bond and build friendships, enhancing the overall enjoyment of the sport.</li>
            </ul>
          </li>
          <li>
            <strong>Faster Game Pace:</strong>
            <ul>
              <li><strong>Quick Matches:</strong> Games are typically shorter, leading to quicker rotations and allowing players to participate in multiple games in one day. This keeps energy levels high and players more engaged</li>
              <li><strong>Less Downtime:</strong> The fast pace minimizes waiting times between plays, creating a more exciting and dynamic environment.</li>
            </ul>
          </li>
          <li>
            <strong>Focus on Teamwork and Strategy:</strong>
            <ul>
              <li><strong>Effective Communication:</strong> The smaller team size encourages players to communicate effectively, fostering teamwork and developing their ability to strategize on the fly.</li>
              <li><strong>Understanding Roles:</strong> Players learn the importance of their specific roles within the team and how to work collaboratively to achieve common goals.</li>
            </ul>
          </li>
          <li>
            <strong>Accessibility and Inclusivity:</strong> Great for players of all skill levels.</li>
          <ul>
            <li><strong>Less Intimidating and more accessible to players of all skill levels:</strong> 3-on-3 basketball is often seen as less intimidating for newcomers, making it an excellent entry point for young players to learn the game.</li>
          </ul>
          <li>
            <strong>Community and Social Engagement:</strong> FAB fosters a strong community spirit.
            <ul>
              <li>
                <strong>Building Bonds:</strong> FAB prioritizes community and fosters community spirit and social interaction among players and their families.

              </li>
            </ul>
</li>
        </ul>
        <p>
          FAB’s 3-on-3 format offers a unique and engaging approach to basketball, emphasizing
          skill development, teamwork, and community, making it ideal for youth players looking
          to enjoy the game and build confidence.
        </p>
      </section>

      <hr className="divider" />

      <section className="youth_section">
        <h3>HOW TO REGISTER</h3>
        <p>Email <a href="mailto:fastactionbasketball@gmail.com">fastactionbasketball@gmail.com</a> to register and learn more.</p>
        {/* <button> Learn More </button> */}
      </section>
    </div>
  );
}

export default FabYouth;
